import React from "react";
import { motion } from "framer-motion";
import { DEMO } from "@/constants/plantusTestIds";

const HERO_MOCKUP = "/screenshots/hero_login.jpg";

const shots = [
  {
    title: "Anwendung erfassen",
    desc: "PSM, Menge, Kultur & EPPO-Code in Sekunden eingegeben.",
    src: "/screenshots/demo1_neue_anwendung.jpg",
  },
  {
    title: "GPS automatisch aufzeichnen",
    desc: "Strecke, Geschwindigkeit und Punkte live während der Behandlung.",
    src: "/screenshots/demo2_gps.jpg",
  },
  {
    title: "Bericht & Export",
    desc: "Behördenkonformes PDF, maschinenlesbares JSON oder beides als ZIP, ein Klick.",
    src: "/screenshots/demo3_export.jpg",
  },
];

export const Demo = () => {
  return (
    <section
      id="demo"
      data-testid={DEMO.section}
      className="relative py-24 sm:py-32 bg-bone-100/70"
    >
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="max-w-2xl mb-14">
          <div className="text-xs font-semibold uppercase tracking-[0.2em] text-terracotta mb-3">
            Demo
          </div>
          <h2 className="font-heading text-3xl sm:text-4xl lg:text-5xl font-semibold text-forest-900 tracking-tight">
            Einfach. Schnell. <span className="text-forest-600">Unkompliziert.</span>
          </h2>
          <p className="mt-5 font-body text-base sm:text-lg text-[#4A524C]">
            Plantus erleichtert Ihren Arbeitsalltag: automatische On-Time-Erfassung
            von GPS, Wetter und Zeit, Sie wählen nur noch Wirkstoff und Menge.
            Schneller geht eine rechtskonforme Aufzeichnung nicht.
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-8 lg:gap-10">
          {shots.map((s, i) => (
            <motion.div
              key={i}
              data-testid={DEMO.shot(i)}
              initial={{ opacity: 0, y: 24 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true, margin: "-60px" }}
              transition={{ duration: 0.6, delay: i * 0.1, ease: "easeOut" }}
              className="group relative"
            >
              <div className="relative mx-auto w-full max-w-[260px] aspect-[9/19] rounded-[2.5rem] bg-gradient-to-br from-forest-700 to-forest-900 p-2 shadow-[0_30px_60px_-20px_rgba(20,30,20,0.35)]">
                <img
                  src={s.src}
                  alt={s.title}
                  className="w-full h-full object-cover rounded-[2.1rem]"
                />
              </div>
              <div className="mt-7 text-center">
                <div className="inline-flex items-center justify-center w-7 h-7 rounded-full bg-terracotta text-white text-xs font-semibold font-heading mb-3">
                  {i + 1}
                </div>
                <h3 className="font-heading text-xl font-medium text-forest-900">
                  {s.title}
                </h3>
                <p className="mt-2 font-body text-sm text-[#4A524C] max-w-xs mx-auto">
                  {s.desc}
                </p>
              </div>
            </motion.div>
          ))}
        </div>
      </div>
    </section>
  );
};
